// src/components/common/StatusSwitcher.js
import React from "react";

export default function StatusSwitcher({
  text1,
  text2,
  isSwitched,
  className,
  duration = 300,
  direction = "horizontal",
}) {
  const isVertical = direction === "vertical";

  const text1Style = {
    transform: isSwitched
      ? isVertical
        ? "translateY(100%)"
        : "translateX(-100%)"
      : "translate(0, 0)",
    opacity: isSwitched ? 0 : 1,
    transitionDuration: `${duration}ms`,
  };

  const text2Style = {
    transform: isSwitched
      ? "translate(0, 0)"
      : isVertical
      ? "translateY(-100%)"
      : "translateX(100%)",
    opacity: isSwitched ? 1 : 0,
    transitionDuration: `${duration}ms`,
  };

  return (
    <div
      className={`relative overflow-hidden w-full flex items-center justify-center ${className}`}
      style={{ height: "100%" }}
    >
      <span
        className="absolute w-full text-center transition-all ease-in-out"
        style={text1Style}
      >
        {text1}
      </span>
      <span
        className="absolute w-full text-center transition-all ease-in-out"
        style={text2Style}
      >
        {text2}
      </span>
    </div>
  );
}
